import React from 'react';
import { classnames } from '../CustomTab/CustomTab';

interface CustomCardI {
    children: React.ReactNode;
    background?: string;
    customClass?: string;
}

const CustomCard = (props: CustomCardI) => {
    const { children, background, customClass } = props;
    return (
        <div
            className={classnames({
                'custom-card__wrapper': true,
                [customClass as string]: customClass,
            })}
            style={{ background: background }}>
            {children}
        </div>
    );
};

export default CustomCard;
